import React from 'react';

const PricingIntro = () => {
    return (
        <section>
            <div className="stg-row stg-large-gap stg-m-normal-gap">
                <div className="stg-col-6 stg-tp-bottom-gap-l stg-m-bottom-gap" data-appear="fade-right" data-unload="fade-left">
                    <div className="infocolors-parallax-media">
                        <img className="infocolors-lazy" src="img/null.png" data-src="img/inner-pages/pricing.jpg" alt="Ignite Your Potential" width="1200" height="1200" />
                    </div>
                </div>
                <div className="stg-col-6 stg-vertical-space-between" data-appear="fade-left" data-unload="fade-right">
                    <div>
                        <h2>Ignite Your Potential</h2>
                        <p className="infocolors-large-text">Unleashing your brand's magic has never been more attainable. Forget one-size-fits-all packages and opaque pricing models.</p>
                        <p>At infocolors, we believe in tailoring solutions to your unique needs and budget. Your spark is special, and your pricing plan should reflect that.</p>
                    </div>
                    <div className="tp-align-right">
                        <a href="contacts.html" className="infocolors-icon-link">
                            <div className="infocolors-icon-wrap">
                                <i className="infocolors-icon infocolors-icon-explore"></i>
                            </div>
                            <div className="infocolors-icon-link-content">
                                <h6>
                                    Join the
                                    <br />
                                    Movement
                                </h6>
                                <span className="infocolors-label">Tell your story</span>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default PricingIntro;
